"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _OptionList = require("./OptionList.style");

var _Selector = _interopRequireWildcard(require("../Selector/Selector"));

var _helpers = require("../../utils/helpers");

var OptionList = function OptionList(_ref) {
  var options = _ref.options,
      selection = _ref.selection,
      selectorType = _ref.selectorType,
      _onChangeCallback = _ref.onChangeCallback,
      opened = _ref.opened,
      name = _ref.name,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, opened && /*#__PURE__*/_react.default.createElement(_OptionList.OptionListWrapper, {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_OptionList.Options, null, options.map(function (_ref2) {
    var value = _ref2.value,
        label = _ref2.label;
    return /*#__PURE__*/_react.default.createElement(_OptionList.Option, {
      key: value
    }, /*#__PURE__*/_react.default.createElement(_Selector.default, {
      label: label,
      name: selectorType === _Selector.SelectorType.Checkbox ? (0, _helpers.getIdFromString)(value) : (0, _helpers.getIdFromString)(name),
      value: value,
      checked: Array.isArray(selection) ? selection.includes(value) : selection === value,
      type: selectorType,
      onChangeCallback: function onChangeCallback(_ref3) {
        var v = _ref3.target.value;
        return _onChangeCallback(v);
      }
    }));
  }))));
};

OptionList.propTypes = {
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string.isRequired,
    label: _propTypes.default.string
  })).isRequired,
  name: _propTypes.default.string.isRequired,
  selection: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
  selectorType: _propTypes.default.oneOf(Object.values(_Selector.SelectorType)),
  onChangeCallback: _propTypes.default.func,
  opened: _propTypes.default.bool,
  className: _propTypes.default.string
};
OptionList.defaultProps = {
  selection: [],
  selectorType: _Selector.SelectorType.Checkbox,
  onChangeCallback: function onChangeCallback() {},
  opened: true,
  className: ''
};
var _default = OptionList;
exports.default = _default;